function isEqual(variant, findParam) {
    for (let paramName in findParam) {
        const paramValue = findParam[paramName];
        const variantValue = variant[paramName];

        if (paramValue !== variantValue) {
            return false;
        }
    }

    return true;
}

function checkIsAvailableParam(param, selectedParamsArr, variants) {
    const currentParamVariant = { ...param };

    selectedParamsArr.forEach(([selectedParamName, selectedParamValue]) => {
        if (!currentParamVariant[selectedParamName]) {
            currentParamVariant[selectedParamName] = selectedParamValue;
        }
    });

    for (let variant of variants) {
        if (isEqual(variant, currentParamVariant) && variant.offer.available) {
            return true;
        }
    }

    return false;
}

function getOfferByParamsGroup(paramsGroup, variants) {
    for (let variant of variants) {
        if (isEqual(variant, paramsGroup)) {
            return variant.offer;
        }
    }

    return null;
}

function getAvailableParams(allParams, selectedParamsArr, variants) {
    const availableParams = {};

    allParams.forEach(([paramName, params]) => {
        availableParams[paramName] = [];

        params.forEach((paramValue) => {
            const isAvailableParam = checkIsAvailableParam({ [paramName]: paramValue }, selectedParamsArr, variants);

            if (isAvailableParam) {
                availableParams[paramName].push(paramValue);
            }
        });
    });

    return availableParams;
}

function getAvailableParamsGroup(primaryParam, variants) {
    const availableParamsGroup = variants.find((variant) => variant[primaryParam.title] === primaryParam.item);
    return { ...availableParamsGroup };
}

export default function useOfferParamsTree(offers) {
    const variants = offers.map((offer) => ({
        ...offer.selectedGroupedParams,
        offer,
    }));

    /**
     * function getOfferByParams
     * @param {Array} allParams
     * @param {Object} selectedParams
     * @param {Object} primaryParam
     * */
    return (allParams, selectedParams, primaryParam) => {
        let newSelectedParams = {};
        let newAvailableParams = {};
        let newOffer = {};
        let controller = null;

        if (window['searchbooster']) {
            controller = window['searchbooster'].api.controller;
        }

        let selectedParamsArr = Object.entries(selectedParams);

        newOffer = getOfferByParamsGroup(selectedParams, variants);

        if (newOffer) {
            newSelectedParams = selectedParams;
        } else {
            const { offer, ...paramsGroup } = getAvailableParamsGroup(primaryParam, variants);
            newSelectedParams = paramsGroup;
            newOffer = offer;
            selectedParamsArr = Object.entries(newSelectedParams);
        }

        // Прогоняем newOffer через метод mapOffer контроллера, если он доступен
        if (controller && typeof controller.mapOffer === 'function') {
            newOffer = controller.mapOffer(newOffer);
        }

        newOffer = JSON.parse(JSON.stringify(newOffer));

        newAvailableParams = getAvailableParams(allParams, selectedParamsArr, variants);

        return {
            newSelectedParams,
            newAvailableParams,
            newOffer,
        };
    };
}
